'use strict';

class SearchCountryRates {
	constructor(props = {}) {
		console.log('SearchCountryRates::constructor(%o)', props);

		this.sellCountries = [];

		let section = document.getElementById('search_country_rates_holder');
		this.form = section.querySelector('.search_country_rates_form');
		this.input = section.querySelector('.destination_input');

		Object.assign(this, props);

		this.pageEvents();
	}

	getMatchDestinations(term) {
		console.log('SearchCountryRates::getMatchDestinations()');

		return this.sellCountries.filter(destination =>
			destination.toLowerCase().includes(term.toLowerCase())
		);
	}

	pageEvents() {
		const that = this;

		new autoComplete({
			minChars: 0,
			cache: 0,
			menuClass: 'search-countries-autocomplete',
			selector: that.input,
			source(term, suggest) {
				if (term !== '') {
					suggest(that.getMatchDestinations(term));
				}
			},
			onSelect() {
				that.form.submit();
			}
		});
	}
}
window.addEventListener('DOMContentLoaded', () => {
	try {
		new SearchCountryRates(searchCountryRatesOptions || {});
	} catch (e) {
		console.error(e);
	}
});
